import React, { useEffect, useState } from "react";
import "./userRegistration.css";
import { jwtDecode } from "jwt-decode";
import { Button } from "antd";
import { Input } from "@vds/inputs";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { acceptInviteEndPoint } from "../../configuration";
import { acceptInvite } from "../../pages/UserGroups/userGroupsService";
import { async } from "q";
import { validatePassword } from "../../global/utility/Utils";
import { USER_REGISTRATION_CONSTANTS, HTTP_STATUS_CODES } from "../../global/constants/constants";
import peopleCountImg from "./../../assets/peoplecount-img.png";
import peopleCountImg2 from "./../../assets/peoplecount-img-2.png";
import objectDetectionImg from "./../../assets/objectdetection-img.png";
import verizonBizLogo from "./../../assets/VerizonBusiness_GlowWordmark_RGB 1.png";

const insightsImages = [peopleCountImg, peopleCountImg2, objectDetectionImg];

const UserRegistration = (props) => {
  const [decodedToken, setDecodedToken] = useState({});
  const [formData, setFormData] = useState({
    password: "",
    verifyPassword: "",
  });
  const [passwordMatch, setPasswordMatch] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isMFAEnabled = window.REACT_APP_IS_MFA_ENABLED === 'true';

  const [isPasswordTouched, setIsPasswordTouched] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    length: false,
    chars: false,
    email: false,
    url: false,
  });
  const [isFieldTouched, setIsFieldTouched] = useState(false);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };
  const token = getQueryParam("token");

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    } else {
      console.error("Invalid token:", token);
    }
  }, [location]);

  const handleFocus = () => {
    setIsFieldTouched(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "verifyPassword" || name === "password") {
      setPasswordMatch(formData.password === value);
    }

    if (name === "password") {
      if (!isPasswordTouched) {
        setIsPasswordTouched(true);
      }

      const email = decodedToken?.invite?.details?.inviteeemail || "";
      const currentUrl = window.location.href;

      const { isValid, errors } = validatePassword(value, email, currentUrl);

      setIsPasswordValid(isValid);
      setValidationErrors(errors);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      firstname: inviteefirstname,
      lastname: inviteelastname,
      mdn: inviteemdn,
      token: getQueryParam("token"),
      password: formData.password,
      rejectmfasms: isMFAEnabled ? false : true,
      rejectmfaemail: isMFAEnabled ? false : true,
      rejectmfaapp: true,
      rejectrecoverycodes: true,
    };
    const response = await acceptInvite(
      payload,
      token,
      acceptInviteEndPoint()
    );
    if (response?.status === HTTP_STATUS_CODES.OK) {
      navigate("/login");
    } else if (response?.status === HTTP_STATUS_CODES.CONFLICT) {
      setIsLinkExpired(true);
    } else {
      console.log("Error in accept invite user flow");
    }
  };

  const { inviteefirstname, inviteelastname, inviteeemail, inviteemdn } =
    decodedToken?.invite?.details || {};
  return (
    <div className="userRegistrationRoot">
      <div className="userRegistrationLeftPanel">
        <img
          src={verizonBizLogo}
          alt="Verizon Business Logo"
          className="userRegistrationLeftPanelLogo"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <div className="userRegistrationLeftPanelContent" >
          <h1 className="userRegistrationLeftPanelTitle">
            {USER_REGISTRATION_CONSTANTS.PAGE_TITLE}
          </h1>
          <p className="userRegistrationLeftPanelSubtitle">
            <span className="highlightedText">
              {USER_REGISTRATION_CONSTANTS.LEFT_PANEL_SUBTITLE}
            </span>{" "}
            {USER_REGISTRATION_CONSTANTS.LEFT_PANEL_DESCRIPTION}
          </p>

          <div className="userRegistrationLeftPanelImages">
            {insightsImages.map((src, index) => (
              <img
              key={src}
              src={src}
              alt={`5G Video Insights feature ${index + 1}`}
              className="userRegistrationLeftPanelImage"
              />
            ))}
          </div>
        </div>
      </div>
      <div className="userRegistrationRightPanel">
        <div className="userRegistrationRightPanelWrapper">
          <br />
          <br />
          {isLinkExpired ? (
            <div className="expiredBlock">
              <div className="font-face-vzb expiredTitle">
                {USER_REGISTRATION_CONSTANTS.INVITE_EXPIRED_TITLE}
              </div>
              <div className="expiredSubtitle">
                {USER_REGISTRATION_CONSTANTS.INVITE_EXPIRED_SUBTITLE}<br />
                {USER_REGISTRATION_CONSTANTS.INVITE_EXPIRED_SUBTITLE2}
              </div>
            </div>
          ) : (
            <>
              <div className="userRegistrationFormWrapper">
                <h1
                className="text-center font-face-vzb userRegistrationWelcomeTitle">
                  {USER_REGISTRATION_CONSTANTS.WELCOME_TITLE}
                </h1>
                <p className="userRegistrationSubtitle">
                  {USER_REGISTRATION_CONSTANTS.CREATE_PASSWORD_SUBTITLE}
                </p>
              </div>
              <br />
              <form className="sasp_login_form userRegistrationForm">
                <div className="userRegistrationFormContent">
                  <div className="userRegistrationInputWrapper">
                    <Input
                      type="text"
                      label="First name"
                      width="382px"
                      name="firstName"
                      readOnly={true}
                      value={inviteefirstname}
                    />
                  </div>
                  <div className="userRegistrationInputWrapperBottom">
                <Input
                  type="text"
                  label="Last name"
                  width="382px"
                  name="lastName"
                  readOnly={true}
                  value={inviteelastname}
                />
              </div>
              <div>
                <Input
                  type="text"
                  label="Username"
                  width="382px"
                  readOnly={true}
                  value={inviteeemail}
                />
                <div className="userRegistrationEmailNote">
                  {USER_REGISTRATION_CONSTANTS.WORK_EMAIL_NOTE}
                </div>
              </div>
              <div className="userRegistrationPasswordWrapper">
                <Input
                  type="password"
                  name="password"
                  width="100%"
                  label="Create password"
                  mask="toggle"
                  error={
                    validationErrors.length ||
                    validationErrors.chars ||
                    validationErrors.email ||
                    validationErrors.url
                  }
                  success={isPasswordValid}
                  value={formData.password}
                  onChange={handleInputChange}
                  status={
                    validationErrors.length ||
                    validationErrors.chars ||
                    validationErrors.email ||
                    validationErrors.url
                      ? "error"
                      : isPasswordValid
                      ? "success"
                      : ""
                  }
                />

                {/* Password validation messages */}
                {isPasswordValid && (
                  <div className="userRegistrationPasswordMessage">
                    {USER_REGISTRATION_CONSTANTS.PASSWORD_VALID_MESSAGE}
                  </div>
                )}

                {isPasswordTouched && (
                  <div>
                    {(validationErrors.length || validationErrors.chars) && (
                      <div className="userRegistrationPasswordMessage">
                        {USER_REGISTRATION_CONSTANTS.PASSWORD_REQUIREMENTS_NOT_MET}
                      </div>
                    )}

                    {!(validationErrors.length || validationErrors.chars) &&
                      validationErrors.email && (
                        <div className="userRegistrationPasswordMessage">
                          {USER_REGISTRATION_CONSTANTS.PASSWORD_CONTAINS_EMAIL}
                        </div>
                      )}

                    {!(validationErrors.length || validationErrors.chars) &&
                      validationErrors.url && (
                        <div className="userRegistrationPasswordMessage">
                          {USER_REGISTRATION_CONSTANTS.PASSWORD_CONTAINS_URL}
                        </div>
                      )}
                  </div>
                )}
                    <div className="userRegistrationPasswordRequirements">
                      <ul className={`userRegistrationPasswordRequirementsList ${!isPasswordTouched ? "untouched" : ""}`}>
                        <li>
                          {USER_REGISTRATION_CONSTANTS.PASSWORD_MIN_LENGTH_REQUIREMENT}
                          </li>
                        <li>
                          {USER_REGISTRATION_CONSTANTS.PASSWORD_COMPLEXITY_REQUIREMENT}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="userRegistrationVerifyPasswordWrapper">
                    <Input
                      width="100%"
                      type="password"
                      name="verifyPassword"
                      label="Verify password"
                      mask="toggle"
                      readOnly={false}
                      required={true}
                      disabled={false}
                      errorText={"Verify password doesn't match"}
                      successText={"Passwords match"}
                      error={isFieldTouched && (!passwordMatch || !formData.verifyPassword)}
                      success={passwordMatch}
                      onFocus={handleFocus}
                      value={formData.verifyPassword}
                      onChange={handleInputChange}
                      status={!passwordMatch ? "error" : passwordMatch && isPasswordValid ? "success" : ""}
                    />
                  </div>
                  <br />
                  <div>
                    <Button
                      type="primary"
                      className="login-pageButton"
                      disabled={!isPasswordValid || !passwordMatch}
                      data-testid="userRegistration_createPasswordButton"
                      onClick={handleSubmit}
                    >
                      {USER_REGISTRATION_CONSTANTS.CREATE_PASSWORD_BUTTON}
                    </Button>
                  </div>
                </div>
                <br />
                <br />
                <p className="userRegistrationTerms">
                  {USER_REGISTRATION_CONSTANTS.TERMS_AGREEMENT_PREFIX} <br />
                  <span>
                    <a href="https://www.verizonenterprise.com/terms?adobe_mc=MCMID%3D79489331358806469974203692604025620162%7CMCORGID%3D7ED836675AB3A4860A495CAD%2540AdobeOrg%7CTS%3D1662453824">
                      {USER_REGISTRATION_CONSTANTS.TERMS_AND_CONDITIONS}
                    </a>
                  </span>{" "}
                  {USER_REGISTRATION_CONSTANTS.TERMS_AGREEMENT_AND}{" "}
                  <a href="https://www.verizonenterprise.com/terms?adobe_mc=MCMID%3D79489331358806469974203692604025620162%7CMCORGID%3D7ED836675AB3A4860A495CAD%2540AdobeOrg%7CTS%3D1662453824">
                    {USER_REGISTRATION_CONSTANTS.PRIVACY_POLICY}
                  </a>
                </p>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
